// extracted by mini-css-extract-plugin
export default {"app":"JVD8V","title":"Uk6Vc","app__stores":"GaMFP","app__install":"M7T3Y","app__install-text":"big4K","app__install-qr":"uzqgY"};